module.exports = __webpack_public_path__ + "static/media/pc_icon_qr_code_hover.dc70b58c.svg";